<div class="flex flex-col gap-4 mt-3 max-sm:gap-2">
  @for ( item of nSubItem; track $index) {

  <div
    class="grid grid-cols-12 gap-2 max-sm:gap-4 bg-white px-4 max-sm:px-2 rounded-6 min-h-[90px] max-sm:min-h-[60px] items-center text-grey-2 font-Roboto-400 text-17 max-sm:text-12"
  >
    <div
      class="flex items-center justify-between col-span-7 gap-1 max-sm:col-span-7 max-sm:flex-col max-sm:justify-start"
    >
      <!-- HOME -->
      <div
        class="flex items-center flex-1 min-w-0 gap-2 max-sm:flex-row max-sm:justify-start max-sm:w-full"
      >
        <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
        <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
        <div class="justify-end hidden max-sm:flex max-sm:ml-auto">
          <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
        </div>
      </div>

      <!-- VS -->
      <div
        class="text-blue-o-50 max-sm:hidden font-inter-700 flex-none min-w-[64px] p-1 max-sm:py-[0.7px] text-center rounded-[16px] text-14 max-sm:text-10 bg-red-4"
      >
        <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
      </div>

      <!-- AWAY -->
      <div
        class="flex flex-row-reverse items-center justify-start flex-1 min-w-0 gap-2 max-sm:w-full max-sm:flex-row max-sm:justify-start"
      >
        <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
        <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
        <div class="justify-end hidden max-sm:flex max-sm:ml-auto">
          <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
        </div>
      </div>
    </div>

    <!-- STATUS -->
    <div
      class="flex items-center justify-center col-span-3 gap-3 max-sm:gap-2 max-sm:col-span-2 max-sm:text-10"
    >
      <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
    </div>

    <!-- ICONS -->
    <div
      class="flex items-center justify-between w-full col-span-2 gap-2 max-sm:col-span-3"
    >
      <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
      <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
      <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
    </div>
  </div>

  }
</div>
